export const STAAR_MULTIPLE_CHOICE_ANSWER = "STAAR-multiple-choice-answer"
